import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {MinMaxSeries} from "../../lq_js_common/e_charts/min_max_median_series";
import {lerpGreenToRedViaOrange} from "../../helpers/scaling";
import {formatCountAxis} from "../../helpers/chart_common";

export class ShaperRttHisto extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Shaper RTT Histogram";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Shaper Round-Trip Time Histogram</h5><p>Shows the average round-trip time for the shaper in the selected time period, as a distribution. More bars in the left is good.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperRttHistoGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "ShaperDetail" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "shaper_detail") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        for (const [key, value] of Object.entries(msg.Data.blob)) {
            this.graph.update(value);
            this.lastGraphState = value;
        }
    }

}

class ShaperRttHistoGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        this.option.yAxis = {};
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        const N_ITEMS = 25;
        let axis = [];
        let d = [];
        for (let i=0; i<data.body.rtt_histogram.length; i++) {
            d.push({
                value: data.body.rtt_histogram[i],
                itemStyle: {color: lerpGreenToRedViaOrange(N_ITEMS-i, N_ITEMS)},
            });
            axis.push((i*20).toString());
        }

        this.option = {
            title: {
                text: 'RTT Histogram',
                left: 'center',
                top: 'top',
                show: true,
                textStyle: {
                    fontSize: 10,
                }
            },
            tooltip: {
                trigger: 'axis',
                confine: true,
                axisPointer: {
                    type: 'shadow'
                },
                textStyle: {
                    fontSize: 10
                },
                formatter: function(params) {
                    let result = '<div style="font-size: 10px;">';
                    if (params[0]) {
                        const rttMs = params[0].name;
                        const samples = params[0].value;
                        result += '<strong>RTT:</strong> ' + rttMs + ' ms<br/>';
                        result += '<strong>Samples:</strong> ' + samples.toLocaleString();
                    }
                    result += '</div>';
                    return result;
                }
            },
            axisPointer: {
                link: {xAxisIndex: 'all'},
                label: {
                    backgroundColor: '#777'
                }
            },
            xAxis: {
                type: 'category',
                name: 'RTT Bucket (ms)',
                axisLabel: {
                    show: true,
                },
                data: axis,
            },
            yAxis: {
                type: 'value',
                name: 'Samples',
                hideOverlap: true,
                axisLabel: {
                    formatter: formatCountAxis,
                },
            },
            series: [
                {
                    type: 'bar',
                    data: d,
                }
            ]
        };

        // Apply
        this.chart.setOption(this.option, true);
    }
}
